import {
  ComponentPropsWithRef,
  forwardRef,
  ForwardRefRenderFunction,
} from 'react';
import styles from './style.module.css';
interface IInput extends ComponentPropsWithRef<'input'> {
  placeholder?: string;
  name: string;
  type: string;
  icon?: any;
  style?: any;
  errors?: string;
  label?: string | JSX.Element;
  prefix?: string | undefined;
}

export const InputBase: ForwardRefRenderFunction<HTMLInputElement, IInput> = (
  { name, type, label, prefix, placeholder, errors, ...rest },
  ref
) => {
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="d-flex align-items-center">
        {prefix && <span className=" p-2">{prefix}</span>}
        <input
          className={styles.input}
          type={type}
          placeholder={placeholder}
          name={name}
          {...rest}
          ref={ref}
        />
      </div>

      <span className={styles.error}>{errors}</span>
    </>
  );
};

export const Input = forwardRef(InputBase);
